module.exports = {"body":"<p><img src=\"/images/projekte/festival01.jpg\" alt=\"Alt-Text\">\n<img src=\"/images/projekte/festival02.jpg\" alt=\"Alt-Text\">\n<img src=\"/images/projekte/festival03.jpg\" alt=\"Alt-Text\">\n<img src=\"/images/projekte/festival04.jpg\" alt=\"Alt-Text\">\n<img src=\"/images/projekte/festival05.jpg\" alt=\"Alt-Text\">\n<img src=\"/images/projekte/festival06.jpg\" alt=\"Alt-Text\"></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./projekte/festival.sidebar.md
// module id = 1006
// module chunks = 0